import { render, staticRenderFns } from "./AdminChatBar.vue?vue&type=template&id=7429ec17&"
import script from "./AdminChatBar.vue?vue&type=script&lang=js&"
export * from "./AdminChatBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports